import { Method } from "axios";
import { LANGUAGE_CODE } from "./Country";
import { Manager } from "@lib/types/Manager";

export enum UserBotNotificationStatusHistory {
  Delivered = "Delivered",
  Failed = "Failed",
  Pending = "Pending",
}
export enum TelegramBotSessionStatusEnum {
  Open = "Open",
  Close = "Close",
}
export enum TelegramBotActionByStatusEnum {
  Agent = "Agent",
  User = "User",
  System = "System",
}
export enum TelegramBotViewEnum {
  BotView = "BotView",
  SessionView = "SessionView",
}

export interface ITelegramPayment {
  name: string;
  token: string;
}

export interface IToggleTelegramBot {
  enabled: boolean;
}

export interface TelegramBotConfig {
  id: string;
  name: string;
  token: string;
  appUrl: string;
  botUrl: string;
  enabled?: boolean;
  paymentProviders?: ITelegramPayment[];
  extraData?: Record<string, unknown>;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
}

interface IWebAppInfo {
  url: string;
}

interface IInlineKeyboardButton {
  text: string;
  url?: string;
  callback_data?: string;
  web_app?: IWebAppInfo;
}

export interface TTelegramBotDialogueRow {
  language: string;
  businessUnitIds?: string[];
  title: string;
  label?: string;
  requireAuth: boolean;
  parentId?: string;
  configId?: string;
  options: IInlineKeyboardButton[][];
  extraData?: Record<string, IBotMessageAction>;
  config: Partial<TelegramBotConfig>;
  parent?: Partial<TTelegramBotDialogueRow>;
  children?: TTelegramBotDialogueRow[];

  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
}

export interface ITelegramBotDialogueRequest {
  language?: LANGUAGE_CODE;
  requireAuth?: boolean;
  configId?: string;
}

export interface ITelegramBotCrmRequest {
  method: Method;
  path: string;
  params?: string;
  data?: Partial<TelegramBotConfig | TTelegramBotDialogueRow>;
}

export interface ITelegramActiveBot {
  active: string[];
}

export interface IBotBaseAction {
  type: any;
  backLabel: string;
}

export interface IBotCheckBalanceAction extends IBotBaseAction {
  checkBalanceMessage: string;
}
export interface IBotDepositAction extends IBotBaseAction {
  depositMessage: string;
  currencyMessage: string;
}

export interface IBotSuccessfulPaymentAction extends IBotBaseAction {
  successMessage: string;
}

export interface IBotAmountAction extends IBotBaseAction {
  amountThreshold: number;
  amountMessage: string;
  errorMessage: string;
  invalidMessage: string;
  amountLabel: string;
  invoiceLabel: string;
}

export type TBotActionTypes =
  | IBotSuccessfulPaymentAction
  | IBotCheckBalanceAction
  | IBotDepositAction
  | IBotAmountAction
  | IBotBaseAction;

export interface IBotMessageAction extends IBotBaseAction {
  checkBalanceMessage?: string;
  depositMessage?: string;
  currencyMessage?: string;
  successMessage?: string;
  amountThreshold?: number;
  amountMessage?: string;
  errorMessage?: string;
  invalidMessage?: string;
  amountLabel?: string;
  invoiceLabel?: string;
  withdrawSourceLabels?: string[];
  withdrawSourceMessage?: string;
  withdrawAccountsMessage?: string;
  withdrawTransactionExistMessage?: string;
  withdrawSuccessMessage?: string;
  chatRequestMessage?: string;
  chatSessionStartedMessage?: string;
  chatSessionEndedMessage?: string;
  chatUserEndedSessionMessage?: string;
}

export const botExtraDataInitialValues: Record<string, any> = {};

export interface IUserTelegramBotConfig {
  chatId: string;
  interactedBots: string[];
  status: "Active" | "Inactive";
  // user?: Pick<IUserRow, "id" | "firstName">;
  user?: any;
}

export interface ISendTelegramNotification {
  chatId: string;
  message: string;
}

export interface ITelegramBotNotificationHistory {
  id: string;
  createdAt?: string;
  completedAt: string;
  chatId: string;
  status: UserBotNotificationStatusHistory;
  botId: string;
  description?: string;
  queueId: string;
  queue?: ITelegramBotNotificationQueue;
  userTelegramBotConfig?: IUserTelegramBotConfig;
}

export interface ITelegramBotNotificationQueue {
  id: string;
  message: string;
  completedAt: string;
  status: UserBotNotificationStatusHistory;
}

export interface ITelegramBotChat {
  id?: string;
  createdAt?: string;
  text: string;
  botSessionId: string;
  sentBy: TelegramBotActionByStatusEnum;
  extraData?: unknown;
  botSession?: ITelegramBotChatSession;
}

export interface ITelegramBotChatSession {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  chatId: string;
  botId: string;
  agentId: string;
  status: TelegramBotSessionStatusEnum;
  closedBy?: TelegramBotActionByStatusEnum;
  closeAgentId?: string;
  telegramBotChat: ITelegramBotChat[];
  userTelegramBotConfig?: IUserTelegramBotConfig;
}

export interface ITelegramMessageInput {
  chatId: number;
  configId: string;
  agentId: string;
  userId: string;
  messageBody: string;
  // user?: Pick<
  //   IUserRow,
  //   "id" | "firstName" | "lastName" | "phoneCode" | "phone"
  // >;
  user?: any;
}

export enum TelegramUserBotStatusEnum {
  Active = "Active",
  Inactive = "Inactive",
}

export interface ITelegramBotExtraData {
  id: number;
  is_bot: boolean;
  last_name: string;
  first_name: string;
  language_code: string;
}

export interface ITelegramBotUser {
  chatId: string;
  interactedBots: string[];
  status: TelegramUserBotStatusEnum;
  unAuthInteractedBots: string[];
  managerId: string;
  manager?: Manager;
  extraData: ITelegramBotExtraData;

  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
}

export enum TelegramBotUSerTypeEnum {
  unAuthInteractedBots = "unAuthInteractedBots",
  interactedBots = "interactedBots",
  all = "all",
}
